// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_924b119625--wrapper--HnEdE","error":"_924b119625--error--DAugs","buttons":"_924b119625--buttons--vFL2r"};